import React, { Component } from 'react';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { injectIntl } from '@atlassian/jira-intl';
import {
	PACKAGE_NAME,
	ERROR_REPORTING_PACKAGE,
	ERROR_REPORTING_TEAM,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant';
import messages from './messages';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props, State } from './types';

// This cannot be converted to functional component https://reactjs.org/docs/error-boundaries.html#introducing-error-boundaries
class CellErrorBoundary extends Component<Props, State> {
	// eslint-disable-next-line react/sort-comp
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch({ message, stack: stackTrace }: Error) {
		const error = new Error(message);
		if (stackTrace) {
			error.stack = stackTrace;
		}

		fireErrorAnalytics({
			meta: {
				id: ERROR_REPORTING_PACKAGE.ROADMAP,
				packageName: PACKAGE_NAME,
				teamName: ERROR_REPORTING_TEAM,
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
	}

	render() {
		if (this.state.hasError) {
			return (
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
				<div className={styles.container}>
					{this.props.intl.formatMessage(messages.anErrorOccurred)}
				</div>
			);
		}

		return this.props.children;
	}
}

export default injectIntl(CellErrorBoundary);
